import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { routinePromiseWatcherSaga } from 'redux-saga-routines'
import { routerMiddleware } from 'connected-react-router'
import createReducer from './reducer'

export default function configureStore(history, initialState = {}) {
  const sagaMiddleware = createSagaMiddleware()
  const middlewares = [
    sagaMiddleware,
    routerMiddleware(history)
  ]

  const enhancers = [applyMiddleware(...middlewares)]

  const composeEnhancers =
    process.env.NODE_ENV === 'development' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose

  const store = createStore(
    createReducer({}, history),
    initialState,
    composeEnhancers(...enhancers)
  )

  // Extensions
  store.runSaga = sagaMiddleware.run
  store.injectedReducers = {}
  store.injectedSagas = {}
  store.history = history

  // run routines promise saga
  store.runSaga(routinePromiseWatcherSaga)

  /* istanbul ignore if */
  if (module.hot) {
    module.hot.accept('./reducer', () => {
      store.replaceReducer(createReducer(store.injectedReducers, history))
    })
  }

  return store
}
